/**
 * Logs tab (§4.4.5).
 *
 * Thin shell around <LogViewer>, which owns the xterm instance.
 * The viewer polls via `useLogs.fetchLogs` — once WS streaming lands,
 * the hook can switch to a subscription with no component changes.
 */
import type { AgentConfig } from '@/api/agents';
import { useLogs } from '@/hooks/useLogs';
import { LogViewer } from '@/components/LogViewer';

interface LogsProps {
  agent: AgentConfig;
}

export default function Logs({ agent }: LogsProps) {
  const { fetchLogs, downloadUrl } = useLogs(agent.name);

  return (
    <div className="h-[calc(100vh-14rem)] min-h-[24rem] rounded-md border overflow-hidden">
      <LogViewer
        onFetchLogs={fetchLogs}
        refreshInterval={2000}
        downloadUrl={downloadUrl}
        agentName={agent.name}
      />
    </div>
  );
}
